import React, { useState } from 'react';
import InternalTransactions from './transactions/InternalList';
import ExternalTransactions from './transactions/ExternalList';

const TransactionList = ({
  walletId
}) => {
  return (
    <React.Fragment>
      <div className='User__header'>
        <h3 className='User__header__h3 User__header__upper-space'>Wallet Transactions</h3>
      </div>

      <InternalTransactions walletId={walletId} />
      <ExternalTransactions walletId={walletId} chain='L1' />
      <ExternalTransactions walletId={walletId} chain='L2' />
    </React.Fragment>
  )
}

export default TransactionList
